import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
}
export function Tooltip({
  children,
  content
}: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  // Close on outside click (mobile)
  useEffect(() => {
    if (!isVisible) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside as any);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside as any);
    };
  }, [isVisible]);
  const toggle = () => setIsVisible(v => !v);
  return <div ref={containerRef} className="relative inline-flex" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} data-id="element-697">
      <div onClick={toggle} data-id="element-698">{children}</div>
      <AnimatePresence data-id="element-699">
        {isVisible && <motion.div ref={tooltipRef} initial={{
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 4
      }} transition={{
        duration: 0.15
      }} className="absolute z-50 w-64 max-w-[calc(100vw-2rem)] p-3 text-sm leading-relaxed text-white bg-gray-900 rounded-xl shadow-xl bottom-full right-0 mb-2" data-id="element-700">
            {content}
            <div className="absolute top-full right-3 border-4 border-transparent border-t-gray-900" data-id="element-701" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}